export default "__VITE_ASSET__C64NpC_C__"